import React, { Component } from "react"
import AnimatedCheckmarkButton from "../common/animatedCheckmarkButton"

class ParkingServiceBanner extends Component {
  static defaultProps = {
    modifier_class: "parking-product-highlight--stagger",
    title: "title",
    body: "body text",
    ribbon: "ribbon",
    modalButtonText: "modalButtonText",
    price: "price DKK",
    buttonText: "buttonText Tilføj",
  }

  state = {}

  render() {
    const { modifier_class, title, ribbon, body, price, modalButtonText, buttonText } = this.props
    return (
      <div className={`service-banner ${modifier_class}`}>
        <div className="grid vertical-center">
          <div className="grid-item col--12 col-sm--3">
            <div className="service-banner__header">
              <h4 className="service-banner__title">{title}</h4>
              {ribbon ? (
                <span className="angled-ribbon angled-ribbon--dynamic">
                  <span className="angled-ribbon__inner">
                    <span className="text">{ribbon}</span>
                  </span>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="grid-item col--12 col-sm--5">
            <div className="rich-text">
              <div dangerouslySetInnerHTML={{ __html: body }}></div>

              <p className="bodytext-sm">
                <button className="simple-link js--open-modal" onClick={this.props.modalButtonOnClick}>
                  {modalButtonText}
                </button>
              </p>
            </div>
          </div>
          <div className="grid-item col--12 col-sm--4">
            <div className="service-banner__price-cta ">
              <div className="price-text">{this.props.priceFormatter(price)}</div>
              <AnimatedCheckmarkButton
                buttonText={buttonText}
                onClickHandler={() => this.props.buttonOnClick(this.props.product, this.props.offer)}
                isSelected={this.props.isSelectedProduct}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ParkingServiceBanner
